import React from 'react'
import { connect } from "react-redux"
import { Form } from 'react-form'

//import { Card } from 'primereact/card'
//import { Message } from 'primereact/message'

import CandidateBoardTable from '../components/candidateBoard/candidateBoard-table'
import CandidateBoardDetails from '../components/candidateBoard/candidateBoard-details'
import * as candidateBoardActionCreators from "../actionCreators/candidateBoard"
import * as appActionCreators from "../actionCreators/app"
import { ROLE_ADMIN } from '../js/const'

import '../css/candidateBoard.css'


class CandidateBoard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isDisplayingDialog: false, // determines whether CandidateBoard details dialog is hidden or shown
      selectedCandidateBoard: {}, // determines what candidateBoard is selcted in the table. It will be highlighted
      newRecord:false,
      selectedIndex:-1,
      deleteBoard :false
    }
    this.deleteCandidateBoard = this.deleteCandidateBoard.bind(this);
    this.confirmDeleteCandidateBoard = this.confirmDeleteCandidateBoard.bind(this);
   
  }

  componentDidMount() {
    document.querySelector('#boardDetailsDialog .p-dialog-titlebar a').setAttribute("aria-label","Close dialog");
  }

  // this function will be called when the form is submitted successfully
  // the CandidateBoard object passed is in the same structure as the object bound to <Form> values property
  // the object will have been updated based on user input
  formSubmittedSuccessfully = candidateBoard => {
    // if id exists then we are updating otherwise we are adding
    // use actionCreators that have been injected in as props. This happens when the higher order component connect is used
 
    if (!this.state.newRecord) {
    //Replace the candidateboard in the list with the updated candidate board
       
        let i = this.state.selectedIndex;
        if(i>-1){
          var data = this.props.candidateBoards;
          data[i] = candidateBoard
          this.props.updateCandidateBoards(data);
        }
           
        if(candidateBoard.CandidateBoardId && candidateBoard.CandidateBoardId !== -1)
        {
          //This is a board that exists in the database so update the database as well
            this.saveCandidateBoardToDB(candidateBoard);
        }
        else
        {
           this.closeCandidateBoardDetails();
        }
    } else {
      //This is a new board. so add a new board to the array and database if required
      candidateBoard.CandidateId = this.props.CandidateId
      this.addNewBoardToCandidateBoards(candidateBoard);
      this.closeCandidateBoardDetails();
    }
  }

  // this function will be called when the form is submitted successfully
  // the CandidateBoard object passed is in the same structure as the object bound to <Form> values property
  // the object will have been updated based on user input
   addNewBoardToCandidateBoards = (candidateBoard) => {
     
        if(this.props.candidateId){
          //candidate exists in database so save board to database
          candidateBoard.CandidateId = this.props.candidateId;
          this.addCandidateBoardToDB(candidateBoard);
        }
        else{
          //This candidate does not exist in the database so add new board to array
          //it will be saved when the candidate is saved
            var data = this.props.candidateBoards;
            candidateBoard.CandidateBoardId = -1;
            data.push(candidateBoard);
            this.props.updateCandidateBoards(data);
        }
  }


   confirmDeleteCandidateBoard (){
      this.setState({ deleteBoard:true})
   }

   deleteCandidateBoard (){
      var candidateToDelete = this.state.selectedCandidateBoard;
      //Get the removed candidate board out of the list
     // var data = this.props.candidateBoards.filter(item=>item.CandidateBoardId != candidateToDelete.CandidateBoardId && item.BoardName != candidateToDelete.BoardPosition &&  item.BoardName != candidateToDelete.BoardPosition );
    //   var data = this.props.candidateBoards.filter(item=>(item.BoardName != candidateToDelete.BoardName &&  item.BoardName != candidateToDelete.BoardPosition) )
      let i = this.state.selectedIndex;
      if(i>-1){
        var data = this.props.candidateBoards;
          data.splice(i,1);

          //update the list of boards of the candidate 
          this.props.updateCandidateBoards(data);

            if(candidateToDelete.CandidateBoardId && candidateToDelete.CandidateBoardId !== -1 )
              {
                //board exists in the database, delete it from the database as well
                  this.deleteCandidateBoardInDB(candidateToDelete);
              }
              else
              {
                this.closeCandidateBoardDetails();
              }
      }
   }

   addNewCandidateBoard = () => this.loadAndOpenCandidateBoardDetails(null)
   selectCandidateBoard = e => this.loadExistingCandidateBoardDetails(e)

  loadExistingCandidateBoardDetails = e => {
     this.setState({
            isDisplayingDialog:true,
            selectedCandidateBoard:  Object.assign({}, e.data),
            newRecord: false,
            selectedIndex:e.index
        });
    var element = document.querySelector('#BoardName');
    if (element)
    {
      window.setTimeout(() => {element.focus();}, 1000);
    }
    var headerCloseButton = document.querySelector('#boardDetailsDialog .p-dialog-titlebar-icons a');
    if (headerCloseButton)
    {
      headerCloseButton.ariaLabel = "Close dialog";
    }
    
  }

  loadAndOpenCandidateBoardDetails = candidateBoard => {
    let candidateBoardId = candidateBoard ? candidateBoard.CandidateBoardId : null
    this.props.setLoading(true)
      .then(() => this.props.getCandidateBoard(candidateBoardId))  
      .then(() => {
        //get board from database. even when null get empty board from database as this brings with it validations for the fields
        let candidateBoard = this.props.candidateBoard.currentCandidateBoard ? this.props.candidateBoard.currentCandidateBoard : {}
 
        let newRecord = candidateBoardId? false :true

        this.setState({ newRecord:newRecord, isDisplayingDialog: true, selectedCandidateBoard: candidateBoard || {} })

        var element = document.querySelector('#BoardName');
        if (element)
        {
          window.setTimeout(() => {element.focus();}, 1000);
        }

      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
      .then(() => this.props.setLoading(false))) 

      
  }

   // this function will be called when the form is submitted successfully
  // the client object passed is in the same structure as the object bound to <Form> values property
  // the object will have been updated based on user input
  saveCandidateBoardToDB = (candidateBoard) => {
    this.props.setLoading(true)
      .then(() => this.props.updateCandidateBoard(candidateBoard))
      .then(response => {
        // set response in store so global response component can handle response
        /*
            response json structure is:
            {
                "$id":"1",
                "SuccessOutput":null,
                "Success":false,
                "ErrorMessages":{
                    "$id":"2",
                    "$values":[
                        "Name is required"
                    ]
                },
                "WarningMessages":{
                    "$id":"3",
                    "$values":[

                    ]
                }
            }
        */
        this.props.setAjaxResponse(response)
        if (response.data.Success) {
          // close dialog by calling function that has been passed in by containing component
          // this is because the state that determines whether the dialog is showing is in the containing component
          this.closeCandidateBoardDetails()
        }
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

   addCandidateBoardToDB = (candidateBoard) => {
     //add board to database
    this.props.setLoading(true)
      .then(() => this.props.addCandidateBoard(candidateBoard))
      .then(response => {
        this.props.setAjaxResponse(response)
        if (response.data.Success) {
          let addedCandidate =  this.props.candidateBoard.currentCandidateBoard
          
          //puth the new added board to the candidate array of boards
          var data = this.props.candidateBoards;
          data.push(addedCandidate);
          this.props.updateCandidateBoards(data);
          //this.closeCandidateBoardDetails()
        }
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }


  deleteCandidateBoardInDB = (candidateBoard) => {
    this.props.setLoading(true)
      .then(() => this.props.deleteCandidateBoard(candidateBoard.CandidateBoardId))
      .then(response => {
        this.props.setAjaxResponse(response)
        if (response.data.Success) {
          // close dialog by calling function that has been passed in by containing component
          // this is because the state that determines whether the dialog is showing is in the containing component
          this.closeCandidateBoardDetails()
        }
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }


  closeCandidateBoardDetails = resetForm => {
    if (resetForm) {
      // reset form to initial state to clear validation errors and bound value
     resetForm();
    }

    this.setState({ isDisplayingDialog: false, deleteBoard:false, selectedCandidateBoard: {} })
    // clear loaded CandidateBoard in store otherwise there is an issue when opening a different lobbyist and the Calendar component where Uncaught TypeError: viewDate.getMonth is not a function
    this.props.clearCandidateBoard()
  }

  formFailedSubmission = (errors, onSubmitError, formApi) => {
    console.log(JSON.stringify(errors));
    if (Object.keys(errors).length > 0)
    {
      let firstErrorObjectId = Object.keys(errors)[0];
      console.log(firstErrorObjectId);
      if (firstErrorObjectId)
      {
        var element = document.querySelector('#' + firstErrorObjectId);
        if (element)
        {
          if (element.tagName.toLowerCase() === "div")
          {
            element = document.querySelector('#' + firstErrorObjectId + ' input');
          }
          if (element)
          {
            element.focus();
          }
        }
      }
    }
  }

  render() {
    // check if current CandidateBoard that is being looked at exists. If not create an empty object to deal with issues that could be caused by CandidateBoard being undefined
    // i.e. when binding to CandidateBoard.Entity.BoardName there could be issues when CandidateBoard is undefined since we are trying to access a property off of a propery
    let currentCandidateBoard = this.state.selectedCandidateBoard? this.state.selectedCandidateBoard:{} // this.props.candidateBoard.currentCandidateBoard ? this.props.candidateBoard.currentCandidateBoard : {}
    let candidateBoards = this.props.candidateBoards ? this.props.candidateBoards : []
    let isAdd = this.state.newRecord
    let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)

    let candidateBoardTableProps = {
      canSave: this.props.canSave,
      candidateBoards: candidateBoards,
      selectCandidateBoard: this.selectCandidateBoard,
      addNewCandidateBoard: this.addNewCandidateBoard,
      selectedCandidateBoard: this.state.selectedCandidateBoard
    }

    return (
      <div title="Board Experience" className="p-grid" style={{margin:"12px"}} >
        <strong  >Board Experience</strong>
      {/*  <Message  severity="" text="Please note: Your board experience will be saved when you Register/Save your application."></Message> */}
        <CandidateBoardTable {...candidateBoardTableProps} />
        {/* values sets the form state. I'm binding to the props which is linked redux so we can update the store and the form will be reflected
        this is useful when needed to clear the form or populating the form from another component
        onSubmit is called when the form has been submitted and has passed validation
        formApi properties can be found at https://react-form.js.org/#/*/}
        <Form values={currentCandidateBoard} onSubmit={this.formSubmittedSuccessfully} onSubmitFailure={this.formFailedSubmission} >
          {formApi => {
            let candidateBoardDetailsProps = {
              currentCandidateBoard: currentCandidateBoard,
              canSave: this.props.canSave,
              submitForm: formApi.submitForm,
              resetForm: formApi.resetAll,
              isAdd: isAdd,
              deleteCandidateBoard: this.deleteCandidateBoard,
              confirmDeleteCandidateBoard:this.confirmDeleteCandidateBoard,
              deleteBoard:this.state.deleteBoard,
              isDisplayingDialog: this.state.isDisplayingDialog,
              closeCandidateBoardDetails: this.closeCandidateBoardDetails,
              isAdmin: isAdmin
            }

            return (
              <CandidateBoardDetails {...candidateBoardDetailsProps} />
            )
          }}
        </Form>
      </div>
    )
  }
}

const mapStateToProps = state => {
  let { candidateBoard, auth } = state
  return { candidateBoard, auth }
} 

// this is how to combine actions available
const actionCreators = {
  ...appActionCreators,
  ...candidateBoardActionCreators
}

export default connect(mapStateToProps, actionCreators)(CandidateBoard);



// WEBPACK FOOTER //
// ./src/container/CandidateBoard.js